/* ORRY FASHION — theme.js */
document.addEventListener('DOMContentLoaded', function () {

  /* ---- mobile nav toggle ---- */
  var toggle = document.querySelector('[data-mobile-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
    });
  }

  /* ---- carousel scroll buttons ---- */
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    var scrollAmount = function () { return track.clientWidth * 0.8; };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
  });

  /* ---- cart drawer ---- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var openers = document.querySelectorAll('[data-cart-open]');
  var closers = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (drawer) drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  openers.forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
  closers.forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); closeCart(); }); });
  if (overlay) overlay.addEventListener('click', closeCart);

  /* ---- add to cart via AJAX API, then refresh drawer ---- */
  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          openCart();
          refreshCartDrawer();
        })
        .catch(function (err) { console.error('Add to cart failed', err); });
    });
  });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshCartDrawer() {
    var container = document.querySelector('[data-cart-drawer-items]');
    if (!container) return;
    fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-items]');
        if (fresh) container.innerHTML = fresh.innerHTML;
      });
  }

  /* ---- quantity / remove inside drawer (event delegation) ---- */
  document.body.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      var key = removeBtn.getAttribute('data-cart-remove');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          refreshCartDrawer();
        });
    }
  });

  /* ---- cookie banner ---- */
  var cookieBanner = document.querySelector('[data-cookie-banner]');
  if (cookieBanner) {
    var CONSENT_KEY = 'orry_cookie_consent';
    var existing = null;
    try { existing = localStorage.getItem(CONSENT_KEY); } catch (e) {}

    if (!existing) {
      setTimeout(function () { cookieBanner.classList.add('is-visible'); }, 600);
    }

    function setConsent(value) {
      try { localStorage.setItem(CONSENT_KEY, value); } catch (e) {}
      cookieBanner.classList.remove('is-visible');
    }

    var acceptBtn = cookieBanner.querySelector('[data-cookie-accept]');
    var declineBtn = cookieBanner.querySelector('[data-cookie-decline]');
    if (acceptBtn) acceptBtn.addEventListener('click', function () { setConsent('all'); });
    if (declineBtn) declineBtn.addEventListener('click', function () { setConsent('necessary'); });
  }
});
